
import Slider from "react-slick";
import { IHomeSlide } from "../../types/home_slider";

function MobileSliderComponent({...props }) {
  const percentage = 50;

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dir:'auto',
    rtl: true,
    autoplay: true,
    arrows: false
  };

    return (

        <div className="col-lg-9  align-self-center position-relative d-lg-none d-block">
            <Slider className="slider-body slick-dots  slider-body-home"  {...settings}>


                {props.slides.map((slideRow: IHomeSlide,index: any) => (
                    <div className="slider-item"  key={index}>
                        <div className="slider-inner-item">
                            <img src={`${process.env.REACT_APP_CMS}${slideRow.Image?.url}`} alt="img" className="img-fluid" />
                            <h3 dir="auto"><a href={slideRow.Url}> {slideRow.Title} </a></h3>
                        </div>
                    </div>
                ))}

            </Slider>

            <div className="mid-img text-center">
                <img src="/static/img/mobile-mid.png" alt="img" className="img-fluid" />
            </div>
            <div className="arrow-down">
                <a href="#progress-bar"><img src="/static/img/arrow-down.png" alt="img" className="img-fluid" /></a>
            </div>
                            </div>
  );
}

export default MobileSliderComponent;


